import * as _4 from 'lodash4';
import * as moment from 'moment';
import {
  IActiveVisit,
  IAppointment,
  IAppointmentCard,
  IAppointmentDetails,
  IAppointmentRequest,
  IAppointmentRequestCard
} from '../types/appointment_interfaces';
import { IOrganizer } from '../types/appt_interfaces';

export class AppointmentInfoServant {
  generateCardInfo(appointment: IAppointment): IAppointmentCard {
    const appointmentDateTime: moment.Moment = moment.unix(appointment.start_timestamp);
    const organizerNames: string = _4
      .map(appointment.organizers, (organizer: IOrganizer) => organizer.first_name + ' ' + organizer.last_name)
      .join(', ');
    const serviceNames: string = this.generateWhy(appointment);
    return {
      month: appointmentDateTime.format('MMM'),
      date: appointmentDateTime.format('DD'),
      day: appointmentDateTime.format('ddd'),
      appointmentType: appointment.appointment_type,
      time: this._formatAppointmentTime(appointment),
      organizer: organizerNames + this._noOfAttendees(appointment),
      location: appointment.location.name,
      service: serviceNames,
      isCancelled: appointment.is_cancelled
    };
  }

  private _noOfAttendees(appointment: IAppointment): string {
    const noOfAttendees: number = _4.size(appointment.attendees) - 1;
    return noOfAttendees > 0 ? ` + ${noOfAttendees} more` : '';
  }

  private _formatAppointmentTime(appointment: IAppointment): string {
    const start_time: moment.Moment = moment.unix(appointment.start_timestamp);
    const end_time: moment.Moment = moment.unix(appointment.end_timestamp);
    if (start_time.format('a') === end_time.format('a')) {
      return start_time.format('h:mm') + ' - ' + end_time.format('h:mm a');
    }
    return start_time.format('h:mm a') + ' - ' + end_time.format('h:mm a');
  }

  generateAppointmentDetails(appointment: IAppointment, studentName: string): IAppointmentDetails {
    const organizerNames: string = _4
      .map(appointment.organizers, (organizer: IOrganizer) => organizer.first_name + ' ' + organizer.last_name)
      .join(', ');
    const serviceNames: string = this.generateWhy(appointment);
    const cancellationHourOffset = appointment.cancellation_lead_time_hours
      ? appointment.cancellation_lead_time_hours
      : 1;
    const cancellationTimeDifference = moment.unix(appointment.start_timestamp).diff(moment(), 'seconds');
    let isNoShow = moment.duration(cancellationTimeDifference, 'seconds').asHours() <= cancellationHourOffset;
    if (cancellationHourOffset === -1) {
      isNoShow = false;
    }

    const meetingURLOrPhone = _4.get(appointment, 'meeting_url_or_phone', '');

    return {
      when:
        moment.unix(appointment.start_timestamp).format('ddd, MMMM D YYYY, h:mm a') +
        ' - ' +
        moment.unix(appointment.end_timestamp).format('h:mm a'),
      why: serviceNames,
      where: appointment.location.name,
      who: studentName + ' with ' + organizerNames + this._noOfAttendees(appointment),
      type: appointment.appointment_type,
      additional_details: appointment.additional_details,
      meeting_url_or_phone: meetingURLOrPhone,
      comments: appointment.comments,
      isNoShow
    };
  }

  generateWhy(appointment: IAppointment) {
    const service = _4.map(appointment.student_services, 'name').join(', ');
    return appointment.course ? `${service} ${appointment.course}` : service;
  }

  generateActiveVsitCardInfo(activeVisit: IActiveVisit) {
    return {
      when: `Checked in on ${moment(activeVisit.check_in_time).format('MMM D, YYYY h:mm a')}`,
      why: _.map(_.get(activeVisit, 'student_services')).join(', '),
      where: activeVisit.location,
      who: activeVisit.staff,
      type: 'Drop in',
      additional_details: '',
      comments: '',
      isNoShow: false,
      meeting_url_or_phone: '',
      can_checkin: false,
      _canCheckout: activeVisit.can_checkout
    };
  }

  generateAppointmentRequestCardInfo(appointmentRequest: IAppointmentRequest): IAppointmentRequestCard {
    return {
      when: `Schedule your appointment by ${moment(appointmentRequest.end_date).format('MMM D, YYYY')}`,
      who: appointmentRequest.creator.first_name + ' ' + appointmentRequest.creator.last_name,
      where: appointmentRequest.location.name,
      why: appointmentRequest.student_service.name,
      details: appointmentRequest.campaign_note
    };
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/servants/appointment_info_servant.ts